export default __webpack_public_path__ + "static/media/bg-mid.a08ef5a9.svg";